import {Address} from "./RouteItems";
import {Button, Grid} from "@mui/material";
import LocationOnIcon from '@mui/icons-material/LocationOn';
import {IconPopupItem} from "./IconPopupItem";
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import {useState} from "react";
import {ManageAlternativeAddresses} from "../../project/manage/summary/ManageAlternativeAddresses";
import {RouteStop} from "../../../api/Logistics";
import {AltAddress} from "../../../api/Projects";
import {AddressManageCustom} from "./AddressManageCustom";
import {AddressManageSupplier} from "./AddressManageSupplier";

export function AddressPopup(props: {
    value: Address|null;
    stop: RouteStop;
    onUpdate(value: RouteStop): Promise<any>;
}) {

    return (
        <div style={{paddingLeft: 8}}>
            <IconPopupItem
                icon={
                    props.value === null ? <LocationOnOutlinedIcon /> :
                        !!(props.stop.projectUseAltAddress || props.stop.projectUseContractorAddress) ? <LocationOnIcon color="primary" /> :
                        <LocationOnIcon/>
                }
            >
                <div style={{padding: 12,
                    paddingTop: 8,
                    paddingBottom: 8,
                }}>
                    <AddressInner stop={props.stop} value={props.value} onUpdate={props.onUpdate} />
                </div>
            </IconPopupItem>
        </div>
    )
}

export function AddressInner(props: {
    value: Address|null;
    stop: RouteStop;
    onUpdate(value: RouteStop): Promise<any>;
}) {

    const [customize, setCustomize] = useState(false);
    const project = props.stop.project;

    if(props.value === null && !project) return null;
    if(customize && project) {
        return (
            <ManageAlternativeAddresses
                onClose={() => {
                    setCustomize(false)
                }}
                project={project}
                includeContractor
                initialContractorId={props.stop.projectUseContractorAddress || undefined}
                initialId={props.stop.projectUseAltAddress || undefined}
                onSelect={(value: AltAddress|null) => {
                    return props.onUpdate(Object.assign({}, props.stop, {
                        projectUseContractorAddress: value?.contractorId || null,
                        projectUseAltAddress: value?.id || null,
                    }))
                }}
            />
        )
    }

    if(customize && props.stop.customTextStop) {
        return <AddressManageCustom
                value={props.stop}
                onUpdate={props.onUpdate}
                onClose={() => setCustomize(false)}
            />
    }

    if(customize && props.stop.manufacturer) {
        return <AddressManageSupplier
                value={props.stop}
                onUpdate={props.onUpdate}
                onClose={() => setCustomize(false)} />
    }

    return (
        <>
            {props.value ? <>
                <div>{props.value.street}</div>
                <div>{props.value.city}</div>
                <div>{props.value.postal}</div>

                <div style={{height: 8}}/>

                {props.stop.projectUseAltAddress && <div style={{fontSize: "0.8rem", paddingBottom: 8}}>* {props.stop.projectUseAltAddressName} Address</div>}
                {props.stop.projectUseContractorAddress && <div style={{fontSize: "0.8rem", paddingBottom: 8}}>* Contractor Address</div>}

            </> : <div style={{color: "grey", paddingTop: 8, paddingBottom: 8}}>No Address</div>}

            <Grid container spacing={1}>
                {props.value && <Grid item>
                    <Button variant="outlined" size="small" onClick={() => {
                        if(!props.value) return;
                        const params = new URLSearchParams();
                        params.append("api", "1");
                        params.append("query", `${props.value.street} ${props.value.city} ${props.value.postal}`);
                        window.open(`https://www.google.com/maps/search/?` + params.toString(), "_blank");
                    }}>
                        View in Google Maps
                    </Button>
                </Grid>}
                <Grid item>
                    <Button variant="outlined" size="small" onClick={() => setCustomize(true)}>
                        Edit
                    </Button>
                </Grid>
            </Grid>
        </>
    )
}